const BOUND_FLAG = 'data-dialog-drag-bound'

function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max)
}

function enableDialogDrag(dialogEl) {
  if (!dialogEl || dialogEl.getAttribute(BOUND_FLAG) === '1') return

  const headerEl = dialogEl.querySelector('.el-dialog__header')
  if (!headerEl) return

  dialogEl.setAttribute(BOUND_FLAG, '1')
  headerEl.classList.add('is-draggable')

  const onMouseDown = (event) => {
    if (event.button !== 0) return
    if (event.target.closest('.el-dialog__headerbtn')) return

    event.preventDefault()

    const rect = dialogEl.getBoundingClientRect()
    const startX = event.clientX
    const startY = event.clientY
    const startLeft = rect.left
    const startTop = rect.top

    dialogEl.style.position = 'fixed'
    dialogEl.style.setProperty('margin', '0', 'important')
    dialogEl.style.setProperty('margin-top', '0', 'important')
    dialogEl.style.transform = 'none'
    dialogEl.style.left = `${startLeft}px`
    dialogEl.style.top = `${startTop}px`
    dialogEl.classList.add('is-dialog-dragged')

    const maxLeft = Math.max(0, window.innerWidth - dialogEl.offsetWidth)
    const maxTop = Math.max(0, window.innerHeight - dialogEl.offsetHeight)

    const onMouseMove = (moveEvent) => {
      const left = clamp(startLeft + moveEvent.clientX - startX, 0, maxLeft)
      const top = clamp(startTop + moveEvent.clientY - startY, 0, maxTop)
      dialogEl.style.left = `${left}px`
      dialogEl.style.top = `${top}px`
    }

    const onMouseUp = () => {
      document.removeEventListener('mousemove', onMouseMove)
      document.removeEventListener('mouseup', onMouseUp)
    }

    document.addEventListener('mousemove', onMouseMove)
    document.addEventListener('mouseup', onMouseUp)
  }

  headerEl.addEventListener('mousedown', onMouseDown)
}

function scanAdminDialogs() {
  document.querySelectorAll('.el-dialog.admin-dialog').forEach(enableDialogDrag)
}

let scanFrame = null
function scheduleScan() {
  if (scanFrame != null) return
  scanFrame = window.requestAnimationFrame(() => {
    scanFrame = null
    scanAdminDialogs()
  })
}

/** 管理端弹窗顶部拖拽（自动绑定 custom-class 含 admin-dialog 的 el-dialog） */
export function initAdminDialogDrag() {
  scanAdminDialogs()

  const observer = new MutationObserver(scheduleScan)
  observer.observe(document.body, { childList: true, subtree: true })
}

/** 也可在单个 el-dialog 上使用 v-dialog-drag */
export default {
  inserted(el) {
    scheduleScan()
    const dialogEl = el.querySelector('.el-dialog') || (el.classList.contains('el-dialog') ? el : null)
    if (dialogEl) enableDialogDrag(dialogEl)
  },
  componentUpdated() {
    scheduleScan()
  },
}
